import { FontFamilyEnum, SiteCoreTypographyData } from './typography.type';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

type HeadingData = {
  h1: SiteCoreTypographyData;
  h2: SiteCoreTypographyData;
  h3: SiteCoreTypographyData;
  h4: SiteCoreTypographyData;
  h5: SiteCoreTypographyData;
  h6: SiteCoreTypographyData;
};

type BodyData = {
  body: SiteCoreTypographyData;
  body1: SiteCoreTypographyData;
  caption: SiteCoreTypographyData;
};

type FormData = {
  formLabel: SiteCoreTypographyData;
  formValue: SiteCoreTypographyData;
};

function getTypographyDefaultData({
  primaryColor,
  secondaryColor,
}: {
  primaryColor: string;
  secondaryColor: string;
}): HeadingData {
  return {
    h1: {
      fontSize: {
        value: '30px',
      },
      tabletFontSize: {
        value: '30px',
      },
      mobileFontSize: {
        value: '24px',
      },
      fontColor: { value: primaryColor },
      fontWeight: {
        value: '600',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    h2: {
      fontSize: {
        value: '32px',
      },
      tabletFontSize: {
        value: '24px',
      },
      mobileFontSize: {
        value: '24px',
      },
      fontColor: { value: secondaryColor },
      fontWeight: {
        value: '600',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    h3: {
      fontSize: {
        value: '24px',
      },
      tabletFontSize: {
        value: '20px',
      },
      mobileFontSize: {
        value: '20px',
      },
      fontColor: { value: secondaryColor },
      fontWeight: {
        value: '600',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    h4: {
      fontSize: {
        value: '22px',
      },
      tabletFontSize: {
        value: '18px',
      },
      mobileFontSize: {
        value: '18px',
      },
      fontColor: { value: secondaryColor },
      fontWeight: {
        value: '600',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    h5: {
      fontSize: {
        value: '22px',
      },
      tabletFontSize: {
        value: '16px',
      },
      mobileFontSize: {
        value: '16px',
      },
      fontColor: { value: secondaryColor },
      fontWeight: {
        value: '800',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
      fontFace: { value: 'SemiBold' },
    },
    h6: {
      fontSize: {
        value: '18px',
      },
      tabletFontSize: {
        value: '18px',
      },
      mobileFontSize: {
        value: '18px',
      },
      fontColor: { value: secondaryColor },
      fontWeight: {
        value: '600',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
  };
}

function getTypographyDefaultBody({
  primaryColor,
  secondaryColor,
}: {
  primaryColor: string;
  secondaryColor: string;
}): BodyData {
  return {
    body: {
      fontSize: {
        value: '18px',
      },
      mobileFontSize: {
        value: '18px',
      },
      tabletFontSize: {
        value: '18px',
      },
      fontColor: { value: primaryColor },
      fontWeight: {
        value: '500',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    body1: {
      fontSize: {
        value: '16px',
      },
      tabletFontSize: {
        value: '16px',
      },
      mobileFontSize: {
        value: '16px',
      },
      fontColor: { value: primaryColor },
      fontWeight: {
        value: '500',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    caption: {
      fontSize: {
        value: '14px',
      },
      tabletFontSize: {
        value: '14px',
      },
      mobileFontSize: {
        value: '14px',
      },
      fontColor: { value: secondaryColor },
      fontWeight: {
        value: '400',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
  };
}

function getTypographyDefaultFormItems({ primaryColor }: { primaryColor: string }): FormData {
  return {
    formLabel: {
      fontSize: {
        value: '14px',
      },
      tabletFontSize: {
        value: '14px',
      },
      mobileFontSize: {
        value: '14px',
      },
      fontColor: { value: primaryColor },
      fontWeight: {
        value: '500',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
    formValue: {
      fontSize: {
        value: '14px',
      },
      tabletFontSize: {
        value: '14px',
      },
      mobileFontSize: {
        value: '14px',
      },
      fontColor: { value: primaryColor },
      fontWeight: {
        value: '500',
      },
      fontFamilyType: { name: FontFamilyEnum.Primary + ', ' + DEFAULT_PRIMARY_FONT_FAMILY },
    },
  };
}

export { getTypographyDefaultData, getTypographyDefaultBody, getTypographyDefaultFormItems };
